if($(window).width() < 768) {
    $('.footer_nav_toggle').click(function(e){
        e.stopPropagation();
        e.preventDefault();
        $(this).toggleClass('bold');
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up')
        $(this).next('.footer_collapsable_nav').slideToggle();
    })
}

const langDropdowns = document.querySelector('.dropdown-toggle.languages[data-toggle="dropdown"]');
if (langDropdowns ) { 
    langDropdowns.addEventListener('mouseenter', function() { langDropdowns.click()  } );
}
